import { BaseFactory } from 'src/services/entity-factory/FactoryInterface';
import AptitudeTest from 'src/entities/AptitudeTest';
import { ApiAptitudeTestSectionResponse } from 'src/services/entity-factory/factories/AptitudeTestSectionFactory';

export interface ApiAptitudeTestResponse {
  aptitudeTest: {
    id: number;
    name: string;
    sections: ApiAptitudeTestSectionResponse[];
  };
}

interface ApiAptitudeTestCreateRequest {
}

export class AptitudeTestFactory extends BaseFactory<AptitudeTest> {
  public toEntity(args: ApiAptitudeTestResponse): AptitudeTest {
    return new AptitudeTest({
      id: args.aptitudeTest.id,
      name: args.aptitudeTest.name,
      sections: args.aptitudeTest.sections ?
        args.aptitudeTest.sections.map(
          section => this.entityFactoryFactory.aptitudeTestSectionFactory.toEntity(section)
        ) : [],
    });
  }

  public toRequest(aptitudeTest: AptitudeTest): ApiAptitudeTestCreateRequest {
    return {};
  }
}


// WEBPACK FOOTER //
// ./src/services/entity-factory/factories/AptitudeTestFactory.tsx